import { render, staticRenderFns } from "./EmvTapDetails.vue?vue&type=template&id=d52ac690&"
import script from "./EmvTapDetails.vue?vue&type=script&lang=js&"
export * from "./EmvTapDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports